import { render, staticRenderFns } from "./VaNotification.vue?vue&type=template&id=d12769f0&scoped=true&"
import script from "./VaNotification.vue?vue&type=script&lang=ts&"
export * from "./VaNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12769f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12769f0')) {
      api.createRecord('d12769f0', component.options)
    } else {
      api.reload('d12769f0', component.options)
    }
    module.hot.accept("./VaNotification.vue?vue&type=template&id=d12769f0&scoped=true&", function () {
      api.rerender('d12769f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/VaNotification.vue"
export default component.exports